



























import { Component, Prop, Mixins, Watch } from 'vue-property-decorator'
import BaseVue from '@/mixins/BaseVue'
import serviceModule from '@/store/modules/ServiceModule'
  import { UserInformations } from '@/services/connecteur'

  @Component({
    components: {}
  })
  export default class KAMAssistantSelect extends Mixins(BaseVue) {
    @Prop({
      default: () => {
        return []
      }
    })
    public id!: number[]

    @Prop({ default: 0, required: true })
    public salesOrgId!: number

    @Prop({ default: false })
    public isCreation!: boolean

    @Prop({ default: false })
    public disabled!: boolean

    public KAMAssistantList: UserInformations[] = new Array<UserInformations>()

    public get kamAssistantError (): string {
      if (this.id && this.id.length) {
        const kams = this.KAMAssistantList.filter(x => this.id?.includes(x.id as number))
        if (!kams.length) {
          this.updateError(true)
          return this.$t('promotion.kamAssistantNotValid').toString()
        } else if (kams[0] && kams[0].desactivated) {
          this.updateError(true)
          return this.$t('promotion.kamAssistantNotActivated').toString()
        }
      }

      this.updateError(false)
      return ''
    }

    public updateError (newValue: boolean) {
      this.$emit('update:error', newValue)
    }

    public updateId (newValue: number[]) {
      this.$emit('update:id', newValue)
    }

    @Watch('salesOrgId', { immediate: true })
    public async updateKAMAssistantList () {
      try {
        if (this.salesOrgId) {
          this.KAMAssistantList = await serviceModule.userApi.getAllKAMAssistants(
            this.salesOrgId
          )
        }
      } catch (error) {
        this.displayError(error)
      }
    }
  }
